import { useState } from "react"

import { MDB_TYPES } from "@meddbriefer/scenario-data/constants"

import { genCheckListItemRec } from "../InterventionsEditor/types"

import { useCheckList } from "./CheckListContext"
import classNames from "classnames"

const INITIAL_STATE = {
    newID: "",
    newLabel: "",
    newType: ""
}
const AddCheckListItem = ({index, phase, subPhase, parentID}) => {
    const [state, setState] = useState(INITIAL_STATE)
    const [errMsg, setErrMsg] = useState("")

    const {uniqueIDs, uniqueLabels, insertRec} = useCheckList()

    const changeHandler = (event) => {
        const {id, value} = event.target
        setState(prevState => Object.assign({}, prevState, {[id]: value}))
    }

    const addHandler = (event) => {
        event.preventDefault()
        if ("" === state.newID) {
            setErrMsg("Please enter an ID")
        } else if ("" === state.newLabel) {
            setErrMsg("Please enter a Label")
        } else if ("" === state.newType) {
            setErrMsg("Please select a type")
        } else if (uniqueIDs.includes(state.newID)) {
            setErrMsg("ID must be unique")
        } else if (uniqueLabels.includes(state.newLabel)) {
            setErrMsg("Label must be unique")
        } else {
            const newRec = genCheckListItemRec(state.newID, state.newType, state.newLabel, phase, subPhase, parentID)
            // console.log("adding", newRec, index)
            insertRec(newRec, index)
            setState(INITIAL_STATE)
            setErrMsg("")
        }
    }

    return (
        <div className="add-item">
            Add CheckList Item:
            <b> ID: </b> <input type="text" id="newID" value={state.newID} size={25} autoComplete="off" onChange={changeHandler} />
            <b> Label: </b> <input type="text" id="newLabel" value={state.newLabel} size={60} autoComplete="off" onChange={changeHandler} />
            <b> Type: </b>
            <select id="newType" value={state.newType} onChange={changeHandler} >
                <option value="">----- Select Type ----------</option>
                <option value={MDB_TYPES.ASSESS}>Assessment</option>
                <option value={MDB_TYPES.AWO}>Assessment w/options</option>
                <option value={MDB_TYPES.DECISION}>Decision</option>
                <option value={MDB_TYPES.NESTED_CHECKLIST}>Nested Checklist</option>
                <option value={MDB_TYPES.REQUIRED}>Required Action</option>
                <option value={MDB_TYPES.CL_PROMPT}>Prompt</option>
            </select>
            <button className="add-btn" onClick={addHandler}>+</button>
            <div className={classNames({"hidden": "" === errMsg})}>{errMsg}</div>
        </div>
    )
}

export default AddCheckListItem